import { useMediaQuery } from '@/shared/lib/useMediaQuery';
import { mobile } from '@/shared/ui/theme';
import { MobileWindowBackButton } from '@/shared/ui/templates';
import { useRelationMobileDetailStore } from '../../model/relationMobileDetailStore';

/**
 * 크리에이터 관계 창의 모바일 제목줄 앞자리 — 상세에서 명부로 돌아가는 ‹.
 * 퀘스트 · 제보 창과 같은 `MobileWindowBackButton` 을 쓴다.
 */
export function CreatorRelationsMobileBack() {
  const isMobile = useMediaQuery(mobile);
  const open = useRelationMobileDetailStore((st) => st.open);
  const setOpen = useRelationMobileDetailStore((st) => st.setOpen);

  if (!isMobile || !open) return null;

  return <MobileWindowBackButton onClick={() => setOpen(false)} />;
}
